import { atom } from 'jotai';

export interface EmailPreferenceType {
  token: string;
  msgId: string;
}

export const $EmailPreference = atom<EmailPreferenceType>({
  token: '',
  msgId: '',
});

$EmailPreference.debugLabel = '$EmailPreference';
